//###########################################################################
// Author Bio – View More / View Less toggle
//###########################################################################

export const authorBio = {
    init() {
        const blocks = document.querySelectorAll('[data-author-bio]')

        if (!blocks.length) {
            return
        }

        for (let i = 0; i < blocks.length; i++) {
            this.handleBlock(blocks[i])
        }
    },

    handleBlock(block) {
        const text = block.querySelector('.author-card__bio-text')
        const toggle = block.querySelector('[data-author-bio-toggle]')

        if (text === null || toggle === null) {
            return
        }

        // Only reveal the toggle when the bio actually overflows the clamp.
        if (text.scrollHeight <= text.clientHeight + 1) {
            return
        }

        toggle.hidden = false

        toggle.addEventListener('click', function () {
            const card = block.closest('.author-card')
            const expanded = card.classList.toggle('is-expanded')
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
        })
    },
}

document.addEventListener('DOMContentLoaded', () => {
    authorBio.init()
})
